import * as abbr from './abbr';
import * as array from './array';
import * as sorts from './sorts';

export const utils = {
    abbr,
    array,
    sorts,
};



// WEBPACK FOOTER //
// ./Assets/Scripts/Util/index.js